import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.1033 3.50285C14.0406 2.56559 15.5602 2.56559 16.4974 3.50285C17.4347 4.4401 17.4347 5.9597 16.4974 6.89696L12.8974 10.497C11.9602 11.4342 10.4406 11.4342 9.50331 10.497C9.03469 10.0283 8.27489 10.0283 7.80626 10.497C7.33763 10.9656 7.33763 11.7254 7.80626 12.194C9.68077 14.0685 12.72 14.0685 14.5945 12.194L18.1945 8.59402C20.069 6.7195 20.069 3.68031 18.1945 1.80579C16.32 -0.0687268 13.2808 -0.0687268 11.4063 1.80579L9.60626 3.60579C9.13763 4.07442 9.13763 4.83422 9.60626 5.30285C10.0749 5.77148 10.8347 5.77148 11.3033 5.30285L13.1033 3.50285Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.10333 9.50285C8.04059 8.56559 9.56019 8.56559 10.4974 9.50285C10.9661 9.97148 11.7259 9.97148 12.1945 9.50285C12.6631 9.03422 12.6631 8.27442 12.1945 7.80579C10.32 5.93127 7.28079 5.93127 5.40628 7.80579L1.80628 11.4058C-0.0682385 13.2803 -0.0682385 16.3195 1.80628 18.194C3.68079 20.0685 6.71999 20.0685 8.5945 18.194L10.3945 16.394C10.8631 15.9254 10.8631 15.1656 10.3945 14.697C9.92587 14.2283 9.16608 14.2283 8.69745 14.697L6.89745 16.497C5.96019 17.4342 4.44059 17.4342 3.50333 16.497C2.56608 15.5597 2.56608 14.0401 3.50333 13.1028L7.10333 9.50285Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }